import React from "react";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = createRoot(document.getElementById("root"));
flushSync(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
const splash = document.getElementById("boot-splash");
if (splash) splash.remove();

// Service worker registration removed: the old cache-first worker served
// stale index.html after deploys, breaking the site. /sw.js now hosts a
// self-destructing worker so previously registered clients clean themselves
// up on their next visit.

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
